module.exports = " <div class=titleBar :class=\"{ 'isLoading': loaders > 0 }\" _v-6fc13fc1=\"\"> <div class=icon _v-6fc13fc1=\"\"> <img src=" + require("../assets/huitparfait-logo.svg") + " _v-6fc13fc1=\"\"> </div> <div class=title _v-6fc13fc1=\"\"><span class=huit _v-6fc13fc1=\"\">Huit</span> Parfait</div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-6fc13fc1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TitleBar.vue
// module id = 324
// module chunks = 2